<template>
        <van-dialog
            v-model="popupServer"
            confirmButtonText="同意并提交"
            confirmButtonColor='#FF7A45'
            @confirm='freightSubmit'
            show-cancel-button
        >
            <Server />
        </van-dialog>
</template>
<script>
import Server from './Server'
export default {
    components: {
        Server
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        popupServer: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        freightSubmit () {
            this.$emit('freightSubmit')
        }
    }
}
</script>